import {useSettings} from '@common/core/settings/use-settings';
import {MultiProductArticleGrid} from '@app/help-center/homepage/multi-product-article-grid';
import {Footer} from '@common/ui/footer/footer';
import React, {ReactNode} from 'react';
import {useLandingPage} from '@app/help-center/homepage/use-landing-page';
import {PageStatus} from '@common/http/page-status';
import {ArticleGrid} from '@app/help-center/homepage/article-grid';
import {ColorfulHeader} from '@app/help-center/homepage/colorful-header';
import {SimpleHeader} from '@app/help-center/homepage/simple-header';

export function LandingPage() {
  const query = useLandingPage();
  const {landing} = useSettings();
  const articles = [
    {
      title: 'Getting Started',
      description:
        "Whether you're new or you're a power user, this article will...",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="58"
          height="59"
          viewBox="0 0 58 59"
          fill="none"
        >
          <path
            opacity="0.2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.2356 33.7289L41.1216 25.1875C41.3934 30.4211 40.102 36.5156 36.1145 43.4711L42.9114 48.9086C43.1531 49.1005 43.4398 49.2276 43.7443 49.2777C44.0489 49.3278 44.3611 49.2993 44.6516 49.1949C44.942 49.0905 45.201 48.9137 45.404 48.6812C45.6069 48.4487 45.7472 48.1683 45.8114 47.8664L48.5981 35.2695C48.6653 35.0025 48.6675 34.7232 48.6044 34.4551C48.5413 34.187 48.4149 33.938 48.2356 33.7289ZM9.62937 33.8648L16.7434 25.3461C16.4716 30.5797 17.763 36.6742 21.7505 43.607L14.9536 49.0445C14.7134 49.2364 14.4284 49.3641 14.1253 49.4155C13.8222 49.4669 13.5111 49.4404 13.221 49.3384C12.931 49.2365 12.6717 49.0624 12.4675 48.8327C12.2633 48.6029 12.1208 48.325 12.0536 48.025L9.26687 35.4055C9.19968 35.1384 9.19754 34.8591 9.26062 34.591C9.32369 34.323 9.45015 34.0739 9.62937 33.8648Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.2354 3.81558C27.7317 3.40466 28.3558 3.17969 29.0004 3.17969C29.6464 3.17969 30.272 3.40573 30.7688 3.8185C32.9652 5.6068 37.7197 10.0433 40.3442 16.8652C41.2556 19.2342 41.9051 21.8784 42.1072 24.7831L49.1359 33.2175C49.4165 33.5468 49.6146 33.9383 49.7137 34.3595C49.8122 34.778 49.8101 35.2138 49.7078 35.6312L46.9238 48.2382L46.9231 48.2413C46.8188 48.7068 46.5978 49.138 46.2809 49.4946C45.9639 49.8511 45.5616 50.1212 45.1116 50.2794C44.6615 50.4376 44.1787 50.4787 43.7084 50.3989C43.2381 50.3192 42.7958 50.1211 42.4231 49.8233L42.4227 49.8229L35.8997 44.6046H22.1012L15.5783 49.8229L15.5778 49.8233C15.2051 50.1211 14.7629 50.3192 14.2926 50.3989C13.8223 50.4787 13.3394 50.4376 12.8894 50.2794C12.4394 50.1212 12.037 49.8511 11.7201 49.4946C11.4032 49.138 11.1821 48.7068 11.0778 48.2413L11.0771 48.2382L8.29317 35.6312C8.19081 35.2138 8.18873 34.778 8.2872 34.3595C8.38636 33.9381 8.58462 33.5464 8.86547 33.217L15.7611 24.9598C15.945 21.9816 16.6071 19.2741 17.5472 16.8537C20.1976 10.03 25.0138 5.59416 27.2354 3.81558ZM40.1379 25.3431C40.123 25.2619 40.1183 25.1794 40.1237 25.0975C39.9496 22.3173 39.3341 19.8096 38.4776 17.5833C36.0288 11.2181 31.5668 7.04659 29.502 5.36613L29.4921 5.35811L29.4921 5.35804C29.3542 5.24281 29.1801 5.17969 29.0004 5.17969C28.8206 5.17969 28.6465 5.24281 28.5086 5.35804L28.4922 5.37139C26.4059 7.0405 21.8841 11.2118 19.4115 17.5778C18.5224 19.8669 17.8924 22.4538 17.7433 25.3289C17.744 25.372 17.7419 25.4151 17.737 25.458C17.5082 30.3576 18.6772 36.0887 22.3319 42.6046H35.663C39.2717 36.0371 40.3985 30.2676 40.1379 25.3431ZM47.6033 34.5026L42.146 27.9537C41.9431 32.5393 40.6085 37.6881 37.5342 43.3509L43.6716 48.2608C43.7792 48.3468 43.907 48.4041 44.0429 48.4271C44.1787 48.4502 44.3182 48.4383 44.4482 48.3926C44.5782 48.3469 44.6945 48.2688 44.786 48.1658C44.8773 48.0631 44.9411 47.939 44.9713 47.8049L44.9716 47.8038L47.7576 35.1874L47.7609 35.1728L47.7643 35.1591C47.7924 35.0471 47.7933 34.93 47.7669 34.8176C47.7405 34.7052 47.6874 34.6008 47.6123 34.5132L47.6033 34.5026L47.6033 34.5026ZM15.7476 28.0962L10.3969 34.5034L10.3887 34.5132L10.3886 34.5132C10.3135 34.6008 10.2605 34.7052 10.234 34.8176C10.2076 34.93 10.2085 35.0471 10.2367 35.1591C10.239 35.1685 10.2412 35.1779 10.2433 35.1874L13.0294 47.8038L13.0296 47.805C13.0599 47.939 13.1236 48.0632 13.2149 48.1659C13.3065 48.2688 13.4227 48.3469 13.5527 48.3926C13.6827 48.4383 13.8222 48.4502 13.9581 48.4271C14.0939 48.4041 14.2217 48.3468 14.3294 48.2608L20.4609 43.3556C17.357 37.7516 15.9855 32.6488 15.7476 28.0962ZM24.3755 50.8546C24.3755 50.3023 24.8232 49.8546 25.3755 49.8546H32.6255C33.1778 49.8546 33.6255 50.3023 33.6255 50.8546C33.6255 51.4069 33.1778 51.8546 32.6255 51.8546H25.3755C24.8232 51.8546 24.3755 51.4069 24.3755 50.8546ZM31.7192 21.8546C31.7192 23.3561 30.502 24.5733 29.0005 24.5733C27.499 24.5733 26.2817 23.3561 26.2817 21.8546C26.2817 20.353 27.499 19.1358 29.0005 19.1358C30.502 19.1358 31.7192 20.353 31.7192 21.8546Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
        </svg>
      ),
      link: '/hc/categories/7/getting-started',
    },
    {
      title: 'First Steps',
      description: 'Are you a new customer wondering how to get started?',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="58"
          height="59"
          viewBox="0 0 58 59"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.2689 8.67196C31.7876 9.15828 31.3688 9.95288 31.029 10.9751C30.6946 11.9815 30.4652 13.1199 30.31 14.2079C30.1553 15.2919 30.0776 16.3018 30.0386 17.0418C30.0358 17.0957 30.0332 17.1481 30.0307 17.199C30.0816 17.1966 30.134 17.194 30.1879 17.1911C30.928 17.1522 31.9378 17.0744 33.0218 16.9198C34.1098 16.7645 35.2483 16.5352 36.2546 16.2007C37.2769 15.861 38.0715 15.4422 38.5578 14.9609C39.3907 14.127 39.8587 12.9967 39.8587 11.818C39.8587 10.6386 39.3901 9.50753 38.5562 8.67357C37.7222 7.83961 36.5911 7.37109 35.4117 7.37109C34.2331 7.37109 33.1027 7.839 32.2689 8.67196ZM39.2633 15.6696L39.9704 16.3767C41.1794 15.1677 41.8587 13.5279 41.8587 11.818C41.8587 10.1082 41.1794 8.46839 39.9704 7.25936C38.7614 6.05032 37.1216 5.37109 35.4117 5.37109C33.7019 5.37109 32.0621 6.05032 30.853 7.25935L30.8499 7.26248C30.0518 8.0677 29.5111 9.20112 29.1311 10.3443C29.0855 10.4815 29.0418 10.6201 28.9999 10.7599C28.958 10.6201 28.9143 10.4815 28.8688 10.3443C28.4888 9.20112 27.9481 8.0677 27.1499 7.26247L27.1468 7.25936C25.9378 6.05032 24.298 5.37109 22.5882 5.37109C20.8783 5.37109 19.2385 6.05032 18.0295 7.25936C16.8205 8.46839 16.1412 10.1082 16.1412 11.818C16.1412 13.5279 16.8205 15.1677 18.0295 16.3767L18.7366 15.6696L18.0326 16.3798C18.3589 16.7032 18.7391 16.9844 19.152 17.2297H9.0625C7.5092 17.2297 6.25 18.4889 6.25 20.0422V27.2922C6.25 28.8455 7.5092 30.1047 9.0625 30.1047H9.875V45.4172C9.875 46.1632 10.1713 46.8785 10.6988 47.406C11.2262 47.9334 11.9416 48.2297 12.6875 48.2297H29H45.3125C46.0584 48.2297 46.7738 47.9334 47.3012 47.406C47.8287 46.8785 48.125 46.1632 48.125 45.4172V30.1047H48.9375C50.4908 30.1047 51.75 28.8455 51.75 27.2922V20.0422C51.75 18.4889 50.4908 17.2297 48.9375 17.2297H38.8479C39.2608 16.9844 39.641 16.7032 39.9673 16.3798L39.2633 15.6696ZM9.0625 19.2297C8.61377 19.2297 8.25 19.5935 8.25 20.0422V27.2922C8.25 27.741 8.61377 28.1047 9.0625 28.1047H10.875H28V19.2297H9.0625ZM30 19.2297V28.1047H47.125H48.9375C49.3862 28.1047 49.75 27.741 49.75 27.2922V20.0422C49.75 19.5935 49.3862 19.2297 48.9375 19.2297H30ZM28 30.1047H11.875V45.4172C11.875 45.6327 11.9606 45.8394 12.113 45.9918C12.2653 46.1441 12.472 46.2297 12.6875 46.2297H28V30.1047ZM30 46.2297V30.1047H46.125V45.4172C46.125 45.6327 46.0394 45.8394 45.887 45.9918C45.7347 46.1441 45.528 46.2297 45.3125 46.2297H30ZM21.7452 16.2007C20.723 15.861 19.9284 15.4422 19.4421 14.9609C18.6091 14.1271 18.1412 12.9967 18.1412 11.818C18.1412 10.6386 18.6097 9.50753 19.4437 8.67357C20.2777 7.83961 21.4088 7.37109 22.5882 7.37109C23.7668 7.37109 24.8972 7.83901 25.731 8.67198C26.2123 9.15831 26.6311 9.95289 26.9708 10.9751C27.3053 11.9815 27.5346 13.1199 27.6899 14.2079C27.8445 15.2919 27.9223 16.3018 27.9613 17.0418C27.9641 17.0957 27.9667 17.1481 27.9691 17.199C27.9183 17.1966 27.8659 17.194 27.812 17.1911C27.0719 17.1522 26.0621 17.0744 24.978 16.9198C23.89 16.7645 22.7516 16.5352 21.7452 16.2007Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
          <path
            opacity="0.2"
            d="M47.125 29.1055V45.418C47.125 45.8987 46.934 46.3597 46.5941 46.6996C46.2542 47.0395 45.7932 47.2305 45.3125 47.2305H12.6875C12.2068 47.2305 11.7458 47.0395 11.4059 46.6996C11.066 46.3597 10.875 45.8987 10.875 45.418V29.1055H47.125Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
        </svg>
      ),
      link: '/hc/categories/7/getting-started',
    },
    {
      title: 'Add External Content',
      description:
        'This article will show you how to expand the functionality of the App.',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="58"
          height="59"
          viewBox="0 0 58 59"
          fill="none"
        >
          <path
            opacity="0.2"
            d="M50.6367 12.793H7.36328C6.2997 12.793 5.4375 13.6552 5.4375 14.7188V43.4922C5.4375 44.5558 6.2997 45.418 7.36328 45.418H50.6367C51.7003 45.418 52.5625 44.5558 52.5625 43.4922V14.7188C52.5625 13.6552 51.7003 12.793 50.6367 12.793Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.6875 14.7188C6.6875 14.3455 6.99006 14.043 7.36328 14.043H50.6367C51.0099 14.043 51.3125 14.3455 51.3125 14.7188V43.4922C51.3125 43.8654 51.0099 44.168 50.6367 44.168H7.36328C6.99006 44.168 6.6875 43.8654 6.6875 43.4922V14.7188ZM7.36328 11.543C5.60935 11.543 4.1875 12.9648 4.1875 14.7188V43.4922C4.1875 45.2461 5.60935 46.668 7.36328 46.668H50.6367C52.3907 46.668 53.8125 45.2461 53.8125 43.4922V14.7188C53.8125 12.9648 52.3907 11.543 50.6367 11.543H7.36328ZM12.6875 20.8555C12.1352 20.8555 11.6875 21.3032 11.6875 21.8555C11.6875 22.4078 12.1352 22.8555 12.6875 22.8555H45.3125C45.8648 22.8555 46.3125 22.4078 46.3125 21.8555C46.3125 21.3032 45.8648 20.8555 45.3125 20.8555H12.6875ZM12.6875 28.1055C12.1352 28.1055 11.6875 28.5532 11.6875 29.1055C11.6875 29.6578 12.1352 30.1055 12.6875 30.1055H45.3125C45.8648 30.1055 46.3125 29.6578 46.3125 29.1055C46.3125 28.5532 45.8648 28.1055 45.3125 28.1055H12.6875ZM11.6875 36.3555C11.6875 35.8032 12.1352 35.3555 12.6875 35.3555H14.5C15.0523 35.3555 15.5 35.8032 15.5 36.3555C15.5 36.9078 15.0523 37.3555 14.5 37.3555H12.6875C12.1352 37.3555 11.6875 36.9078 11.6875 36.3555ZM21.75 35.3555C21.1977 35.3555 20.75 35.8032 20.75 36.3555C20.75 36.9078 21.1977 37.3555 21.75 37.3555H36.25C36.8023 37.3555 37.25 36.9078 37.25 36.3555C37.25 35.8032 36.8023 35.3555 36.25 35.3555H21.75ZM42.5 36.3555C42.5 35.8032 42.9477 35.3555 43.5 35.3555H45.3125C45.8648 35.3555 46.3125 35.8032 46.3125 36.3555C46.3125 36.9078 45.8648 37.3555 45.3125 37.3555H43.5C42.9477 37.3555 42.5 36.9078 42.5 36.3555Z"
            fill="#2F2B3D"
            fillOpacity="0.7"
          />
        </svg>
      ),
      link: '/hc/categories/7/getting-started',
    },
  ];
  return (
    <Layout>
      {query.data ? (
        landing?.content?.variant === 'multiProduct' ? (
          <MultiProductArticleGrid data={query.data} />
        ) : (
          <ArticleGrid data={query.data} />
        )
      ) : (
        <PageStatus
          query={query}
          show404={false}
          delayedSpinner={false}
          loaderIsScreen={false}
        />
      )}
      <div className="bg-gray-50 pt-[15%] ">
        <h2 className="pb-[2%] text-center text-2xl font-medium text-[#2F2B3D] opacity-90">
          Popular Articles
        </h2>
        <div className="grid gap-[2%] text-[#2F2B3D] opacity-90 md:grid-cols-3 ">
          {articles.map((article, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-3 rounded-md border border-[#2F2B3D]  border-opacity-12 bg-white p-24 text-center"
            >
              <div className="text-4xl ">{article.icon}</div>
              <h3 className="text-lg font-medium ">{article.title}</h3>
              <p className="line-clamp-2 max-w-240 text-sm">
                {article.description}
              </p>
              <a
                href={article.link}
                className="hover:bg-teal-600 mt-[2%] rounded bg-[#8eded4] bg-opacity-26 px-4 py-2 text-sm hover:bg-opacity-50"
              >
                <span
                  style={{
                    background:
                      'var(--Main-Color, linear-gradient(95deg, #13B9A1 0%, #1E677D 100%))',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  Read More
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

interface LayoutProps {
  children: ReactNode;
}
function Layout({children}: LayoutProps) {
  const {landing} = useSettings();
  return (
    <div className="isolate">
      {landing?.header?.variant === 'simple' ? (
        <SimpleHeader />
      ) : (
        <ColorfulHeader />
      )}
      <div className="test container mx-auto mb-60 px-14 md:px-24">
        <main className="relative z-10 min-h-850">{children}</main>
      </div>

      {landing?.show_footer && <Footer className="px-40" />}
    </div>
  );
}
